import React, { lazy, Suspense } from 'react';
import Loader from 'react-loaders';
import { Redirect, Route, Switch } from 'react-router-dom';
// Layout
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import ThemeOptions from '../../Layout/ThemeOptions';
import { withAuth } from '../../utils/auth';
import * as storageService from '../../utils/storage';
import { MyNav } from '../AppNav/NavItems';

const UserProfilePage = lazy(() => import('../../pages/user/pages/user-profile.page'));

const AuthRoute = (props) => {
  const { component: Component, canAccess, ...rest } = props

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route {...rest} render={props => (canAccess ? <Component {...props} /> : <Redirect to="/" />)} />
  );
};

const RoutePrivate = () => {
  const user = storageService.getCurrentUser();
  const checkedNavs = MyNav.map(item => (
    {
      ...item,
      canAccess: !item.roles || item.roles.includes(user.role_id)
    }
  ))

  return (
    <Suspense
      fallback={
        <div className="loader-container">
          <div className="loader-container-inner">
            <div className="text-center">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        </div>
      }>
      <Switch>
        {checkedNavs.map((item, index) => (
          <AuthRoute key={index} path={item.path} canAccess={item.canAccess} component={item.component} />
        ))}
        <Route exact path="/profile" component={UserProfilePage} exact />
        <Redirect exact from="*" to='/register-warranty' />
      </Switch>
    </Suspense>
  );
};

export default withAuth(RoutePrivate);
